import { Box, Button, Chip, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addItemNote, addNote } from "../../reduxStore/slices/cartSlice";
import AppButton from "../app-button/AppButton";
import AppDialog from "../app-dialog/AppDialog";

function InstructionsDialog({
  itemsNote,
  item,
  noteType,
  isInstructionsDialogOpen,
  onDialogCancel,
}) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [instruction, setInstruction] = useState("");

  const presetInstructions = [
    "No onions",
    "Extra cheese",
    "Less spicy",
    "Extra spicy",
    "More gravy",
    "Less oil",
    "Crispy",
    "Soft",
    "Add butter",
    "No garlic",
    "Gluten free",
    "Serve hot",
  ];

  useEffect(() => {
    setInstruction(noteType === "item" ? item?.note : itemsNote);
  }, [noteType]);

  const handleChipClick = (text) => {
    let updated = instruction ? `${instruction}, ${text}` : text;
    setInstruction(updated);
  };

  const saveNote = () => {
    if (noteType === "item") {
      dispatch(addItemNote({ note: instruction, variant_uid: item.variant_uid }));
    } else {
      dispatch(addNote(instruction));
    }
  };

  const dialogInstructionsFooter = (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button size="medium" onClick={onDialogCancel}>
        Cancel
      </Button>
      <AppButton
        disabled={isLoading}
        isLoading={isLoading}
        fullWidth
        size="medium"
        variant="contained"
        onClick={() => {
          saveNote();
          onDialogCancel();
        }}
      >
        Save
      </AppButton>
    </Box>
  );

  return (
    <AppDialog
      maxWidth="xs"
      isOpen={isInstructionsDialogOpen}
      id="instructions_dialog"
      title={
        instruction ? "Edit Kitchen Instructions" : "Add Kitchen Instructions"
      }
      footer={dialogInstructionsFooter}
    >
      <Box sx={{ m: "20px 5px" }}>
        <TextField
          autoFocus
          multiline
          label="Enter instructions"
          fullWidth
          autoComplete="off"
          name="kitchen_instructions"
          type="text"
          rows={2}
          value={instruction}
          onChange={(e) => {
            setInstruction(e.target.value);
          }}
          helperText="Special notes for the kitchen. Ex. No onions, extra cheese etc."
        />

        <Box
          sx={{
            mt: 2,
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {presetInstructions.map((preset, index) => (
            <Chip
              key={index}
              label={preset}
              size="small"
              onClick={() => handleChipClick(preset)}
            />
          ))}
        </Box>
      </Box>
    </AppDialog>
  );
}

export default InstructionsDialog;
